import { VehicleType } from '../../codegen/vehicles';
import { CustomFormattedMessage } from '../../i18n/i18n';
import { Vehicle } from '../../models';
import { VehicleIcon } from '../icons/VehicleIcon';

type SidebarVehicleHeadlineProps = {
  vehicle?: Vehicle;
};

export const SidebarVehicleHeadline = ({
  vehicle,
}: SidebarVehicleHeadlineProps) => {
  return (
    <h5>
      <span className={'text-color-dark white-space-nowrap'}>
        <VehicleIcon
          type={vehicle ? vehicle.type : VehicleType.Truck}
          className={'margin-right-5'}
        />
        <span className="margin-right-5">
          {vehicle ? (
            vehicle.name
          ) : (
            <CustomFormattedMessage id={'common.vehicle.unknown'} />
          )}
        </span>
      </span>
    </h5>
  );
};
